import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const TempAdminLogin = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Processing...');

  useEffect(() => {
    const token = searchParams.get('t');
    const refresh = searchParams.get('r');
    const uid = searchParams.get('uid');
    const email = searchParams.get('e');

    if (token && refresh && uid && email) {
      // Save tokens to localStorage on THIS domain
      localStorage.setItem('accessToken', token);
      localStorage.setItem('refreshToken', refresh);
      localStorage.setItem('user', JSON.stringify({
        id: uid,
        email: email,
        first_name: 'Admin',
        last_name: 'User',
        role: 'super_admin',
        status: 'active',
      }));
      setStatus('Logged in! Redirecting to admin dashboard...');
      window.location.href = '/admin';
    } else {
      setStatus('No tokens found. Please use the login button on the backend page.');
    }
  }, [searchParams]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif', background: '#F8FAFC',
    }}>
      <div style={{
        background: '#fff', border: '1px solid #E2E8F0', borderRadius: 12,
        padding: '48px 32px', maxWidth: 380, width: '100%', textAlign: 'center',
      }}>
        <p style={{ fontSize: 16, color: '#1e293b' }}>{status}</p>
      </div>
    </div>
  );
};

export default TempAdminLogin;
